import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { NavigationStart, NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import * as globalConstant from '../../global_constant';
import { SettingsService } from '../../services/Settings.service';

import { CommonModule, isPlatformBrowser } from '@angular/common';
import { SharedModule } from '../../share/shared.module';

@Component({
	selector: 'vebo-footer',
	standalone: true,
	imports: [
		/* FormsModule,
		ReactiveFormsModule, */
		SharedModule
	],
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

	copy_right: any;
	isBrowser: boolean;
	settings_data: any;
	login: any = '';
	currentYear: any = '';
	captchaData: any;
	facebookSocialLink = globalConstant.FACEBOOK_SOCIAL_LINK
	linkedinSocialLink = globalConstant.LINKEDIN_SOCIAL_LINK
	pinterestSocialLink = globalConstant.PINTEREST_SOCIAL_LINK
	instagramSocialLink = globalConstant.INSTAGRAM_SOCIAL_LINK
	tiktokSocialLink = globalConstant.TIKTOK_SOCIAL_LINK
	androidAppDownloadLink = globalConstant.ANDROID_APP_DOWNLOAD_LINK
	iphoneAppDownloadLink = globalConstant.IOS_APP_DOWNLOAD_LINK

	constructor(
		private settingService: SettingsService,
		public router: Router,
		@Inject(PLATFORM_ID) platformId: Object
	) {
		this.currentYear = new Date().getFullYear()
		this.isBrowser = isPlatformBrowser(platformId);
		if (this.isBrowser) {
			if (typeof window !== 'undefined') {
				window.scrollTo(0, 0);
			}
		}
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				if (this.isBrowser) {
					if (typeof localStorage !== 'undefined') {
						if (localStorage.getItem('authUser')) {
							this.login = true;
						} else {
							this.login = false;
						}
					}
				}
			}
		});

	}

	ngOnInit() {
		if (this.isBrowser) {
			this.settingService.get_settings().subscribe(res => {
				if (res.response == "success") {
					this.settings_data = res?.data;
					localStorage.setItem('captchaSetting', JSON.stringify(res?.extra_settings))
				}
			});
		}

	}

	ngAfterViewInit() {
		if (this.isBrowser) {
			var msgProp = document.getElementById("msgIocnFixed")
			if (msgProp != null && msgProp != undefined) {
				msgProp.classList.add('open');
			}
		}

	}
}
